import { render } from "./ItemVe.vue?vue&type=template&id=6ae108f9&scoped=true"
import script from "./ItemVe.vue?vue&type=script&lang=js"
export * from "./ItemVe.vue?vue&type=script&lang=js"

import "./ItemVe.vue?vue&type=style&index=0&id=6ae108f9&scoped=true&lang=css"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ae108f9"]])

export default __exports__